/** 로컬 달력 기준 `yymmdd` (표시용). 파싱 불가면 빈 문자열 */
export function dateToYymmdd(
  startDate: string | number | null | undefined,
): string {
  if (startDate == null) return "";

  if (typeof startDate === "number" && Number.isFinite(startDate)) {
    return yymmddFromMs(normalizeEpochMs(startDate));
  }

  const s = String(startDate).trim();
  if (!s) return "";

  const directNum = Number(s);
  if (
    !Number.isNaN(directNum) &&
    Number.isFinite(directNum) &&
    /^\d+$/.test(s) &&
    directNum > 1e9
  ) {
    return yymmddFromMs(normalizeEpochMs(directNum));
  }

  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (m) {
    return `${m[1].slice(-2)}${m[2]}${m[3]}`;
  }

  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  return yymmddFromDate(d);
}

function normalizeEpochMs(n: number): number {
  /** 10자리 이하면 초 단위로 간주 */
  return n < 1e12 ? n * 1000 : n;
}

function yymmddFromMs(ms: number): string {
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return "";
  return yymmddFromDate(d);
}

function yymmddFromDate(d: Date): string {
  const yy = String(d.getFullYear()).slice(-2);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yy}${mm}${dd}`;
}

/** 행사명 앞에 시작 `yymmdd` + 공백 접두 (`startDate` 없으면 이름만) */
export function eventDisplayLabel(
  name: string,
  startDate?: string | number | null,
  endDate?: string | number | null,
): string {
  const start = dateToYymmdd(startDate);
  const end = dateToYymmdd(endDate);

  return `${name} / 행사기간: ${start} ~ ${end}`;
}
